import React from "react";
import { Helmet } from "react-helmet-async";

const AboutSEO = () => {
  return (
    <Helmet>
      <title>About Themiya Induwara | Full Stack Developer</title>
      <meta
        name="description"
        content="Learn about Themiya Induwara Bandara - A passionate Software Engineer with 5+ years of experience in Full Stack Development and Cross-platform mobile applications."
      />
      <meta
        name="keywords"
        content="Themiya Induwara About, Software Engineer Sri Lanka, Full Stack Developer Profile, Mobile App Developer Biography, Themiya Skills, Themiya Experience"
      />
      <link rel="canonical" href="https://themiya.dev/about" />
    </Helmet>
  );
};

export default AboutSEO;
